<template>
    <div class="goal-item">
        <div class="top-text relative">
            <span class="title-text font14px text-bold">{{title}}</span>
        </div>
        <div class="progress-bar-outer">
            <div class="el-progress-bar__inner" :style="{width:goalRate}"></div>
        </div>
        <div class="top-text clear-both">
            <p class="fl">{{goal.actual_amount}}（{{goal.actual_rate}}）</p>
            <p class="fr">{{goal.target_amount}}</p>
        </div>
    </div>
</template>

<script>
    export default {
        name: "OrderItem",
        props:{
            platId:{
                type:[String,Number],
                require:true,
            },
            goal:{
                type:Object,
                require:true,
            },
        },
        data(){
            return {
                platMap:{
                   1:'OPPO',
                   3:'vivo',
                   4:'华为',
                   7:'小米',
                },
            }
        },
        computed:{
            title(){
                return this.platMap[this.platId];
            },
            goalRate(){
                let rate = this.goal.actual_rate;
                return !rate||rate=='-'||rate=='--'?'0':rate;
            }
        },
        methods:{
        }
    }
</script>

<style lang="scss" scoped>
    .goal-item{
        position: relative;
        border-radius: 5px;
        margin-right: 8px;
        padding: 3px;
        color: #333;
        .progress-bar-outer{
            width: 100%;
            height: 6px;
            background-color: #d7d7d7;
            border-radius: 3px;
            position: relative;
            .el-progress-bar__inner{
                height: 100%;
                /*width: 50%;*/
                max-width: 100%;
                background-color: #a3c7ff;
            }
        }

        .top-text{
            line-height: 16px;
            margin: 2px 0;
        }
    }
</style>
